module.exports = __webpack_public_path__ + "img/img3_zhTc.b4d1532b.png";